import Vue from 'vue';
import AppView from './App.vue';
import store from './store';

import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import 'bootstrap/dist/css/bootstrap-grid.min.css';

Vue.use(Vuetify);

class App {
    private instance?: Vue;

    private init() {
        this.instance = new Vue({
            el: '#app',
            store,
            vuetify: new Vuetify({
                icons: {
                    iconfont: 'md',
                },
            }),
            render: h => h(AppView),
            // mounted: () => {
            // }
        });
    }

    constructor() {
        this.init();
    }
}

new App();